// extracted by mini-css-extract-plugin
module.exports = {"share_compoment":"Share_share_compoment__U6WZP","refer_modal":"Share_refer_modal__8EIL0","no_active_modal":"Share_no_active_modal__7QYE4"};